export const EMAIL_REQUEST_NOTE =
  'Please note that each email account is chargeable to the respective Project / Department approximately between 700 to 1000 AED yearly. An automated MR will be initiated upon the confirmation & approal from PM/HOD.';
